export default "__VITE_ASSET__oR1M1_QK__"